module.exports = __webpack_public_path__ + "static/media/7_angel_tiger.ed44b7f6.png";